export default __webpack_public_path__ + "static/media/pricing-05-image-02.ab0a5c9f.png";